import { Extension } from '@tiptap/core';
import {
    DetectAnswerExplanationNode,
    DetectAnswerExplanationNodeHeadless,
    DetectAnswerNode,
    DetectAnswerNodeHeadless,
    DetectAnswerOptionMark,
    DetectAnswerOptionNode,
    DetectAnswerOptionNodeHeadless,
    DetectAnswerQuestionNode,
    DetectAnswerQuestionNodeHeadless,
} from './detect-answer-extension';

export const DetectAnswerHeadless = Extension.create({
    name: 'detectAnswerWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [
            DetectAnswerNodeHeadless,
            DetectAnswerQuestionNodeHeadless,
            DetectAnswerOptionNodeHeadless,
            DetectAnswerExplanationNodeHeadless,
            DetectAnswerOptionMark,
        ];
    },
});

export const DetectAnswer = DetectAnswerHeadless.extend({
    addExtensions() {
        return [DetectAnswerNode, DetectAnswerQuestionNode, DetectAnswerOptionNode, DetectAnswerExplanationNode, DetectAnswerOptionMark];
    },
});

export default DetectAnswer;
